import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { fetchEmployeesFirstPage } from "./api";
import { fullName } from "./employee-display";

/**
 * employee_id → full name over the FIRST page of the caller's employee list.
 *
 * For rows whose own route returns only an employee id (orphaned punches,
 * devices). A person past the first page, or outside the caller's scope, has no
 * entry: the caller must render its id fallback, never a guessed name.
 */
export function useEmployeeNames(): ReadonlyMap<string, string> {
  const query = useQuery({
    queryKey: ["employees", "first-page-names"],
    queryFn: fetchEmployeesFirstPage,
  });
  return useMemo(
    () => new Map((query.data?.items ?? []).map((row) => [row.employee_id, fullName(row)])),
    [query.data],
  );
}
